<template>
  <div class="login_index">
    <div class="login_leftBox"></div>
    <div class="login_rightBox">
      <div class="login_formBox">
        <div v-if="formType==1" class="login_welcomeText">
          <div class="row1">你好</div>
          <div class="row2">欢迎登录会员中心</div>
        </div>
        <div v-if="formType==0" class="login_welcomeText">
          <div class="row2">会员注册</div>
        </div>
        <div class="login_checkType">
          <div :class="{'login_checkType_item':formType==0,'login_checkType_item_checked':formType==1}"
               @click="changeType(1)">
            <div class="item_title">用户登录</div>
            <div class="item_checked_icon"></div>
          </div>
          <div :class="{'login_checkType_item':formType==1,'login_checkType_item_checked':formType==0}"
               @click="changeType(0)">
            <div class="item_title">免费注册</div>
            <div class="item_checked_icon"></div>
          </div>
        </div>
        <div v-show="formType==1" class="login_form_input">
          <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" class="demo-ruleForm">
            <el-form-item prop="phone">
              <el-input v-model="loginForm.phone" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item prop="verCode">
              <div class="input_button">
                <el-input v-model="loginForm.verCode" placeholder="请输入图形验证码"></el-input>
                <div class="verCode" @click="getcapchat"><img :src="verCode" alt=""></div>
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock"
                        type="password"></el-input>
            </el-form-item>
          </el-form>
          <!--          <div class="login_form_inputAction">-->
          <!--            <div class="automatic_login">-->
          <!--              <el-checkbox v-model="automaticLogin" @change="changIsAutomaticLogin">自动登录</el-checkbox>-->
          <!--            </div>-->
          <!--            <div class="forGetPassword">-->
          <!--              忘记密码-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="sendBtn" @click="login()">登 录</div>
        </div>
        <div v-show="formType==0" class="login_form_input">
          <el-form ref="registerForm" :model="registerForm" :rules="registerFormRules" class="demo-ruleForm">
            <el-form-item prop="phone">
              <el-input v-model="registerForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="verCode">
              <div class="input_button">
                <el-input v-model="registerForm.verCode" placeholder="请输入图形验证码"></el-input>
                <div class="verCode" @click="getcapchat"><img :src="verCode" alt=""></div>
              </div>

            </el-form-item>
            <!--            <el-form-item prop="numberCode">-->
            <!--              <div class="input_button">-->
            <!--                <el-input v-model="registerForm.numberCode" placeholder="请输入验证码"></el-input>-->
            <!--                <el-button class="sendCodeBtn" type="primary" >获取验证码</el-button>-->
            <!--              </div>-->

            <!--            </el-form-item>-->
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" placeholder="请输入不少于8位密码" type="password"></el-input>
            </el-form-item>
          </el-form>
          <div class="sendBtn" @click="register()">注 册</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { post } from "../../utils/request";

export default {
  name: "login_index",
  data () {
    // 自定义验证
    const validPhone = (rule, value, callback) => {

      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.length < 8) { //判断用户输入的值是否符合规则
        callback(new Error('请输入不少于8位密码'))
      } else {
        callback()
      }
    }
    return {
      formType: 1,

      loginForm: {
        phone: "",
        password: "",
        numberCode: '',
        verCode: ''

      },
      registerForm: {
        phone: '',
        password: '',
        numberCode: '',
        verKey: '',
        verCode: ''
      },
      verCode: '',
      automaticLogin: true,
      loginFormRules: {
        phone: [
          { pattern: /^1[3-9]\d{9}$/, required: true, message: '请输入账号/手机号', trigger: 'blur' }
        ],
        verCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      registerFormRules: {
        phone: [
          { pattern: /^1[3-9]\d{9}$/, required: true, message: '请输入账号/手机号', trigger: 'blur' }

        ],
        verCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        numberCode: [
          { required: false, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validPhone, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getcapchat()
    if (this.$route.query.type) {
      this.formType = this.$route.query.type
    }
  },
  methods: {
    changeType (type) {
      this.formType = type
      this.getcapchat()
      this.$refs.loginForm.resetFields()
    },
    login () {
      let self = this;
      this.$refs.loginForm.validate(v => {
        if (v) {
          post('/gateway/appLogin', this.loginForm).then(res => {
            if (res.code === 0) {
              this.loginForm = {
                numberCode: ''
              }
              localStorage.setItem('memberId', res.data.id)
              this.$router.push('/')
              this.$message.success('登录成功！')
            } else {
              self.$message.error(res.msg)
            }
          }).catch(err => {
            self.getcapchat()
          })
        }
      })
    },
    register () {
      let self = this;
      this.$refs.registerForm.validate(v => {
        if (v) {
          post('/gateway/register', this.registerForm).then(res => {
            if (res.code === 0) {
              this.registerForm = {
                phone: '',
                password: '',
                numberCode: '',
                verKey: '',
                verCode: ''
              }
              self.getcapchat()
              this.$message.success('注册成功！')
            } else {
              self.$message.error(res.msg)
            }
          }).catch(err => {
            self.getcapchat()
          })
        }
      })
    },
    getcapchat () {
      post('/gateway/captcha').then(res => {
        // this.registerForm.verCode = res.data.image
        this.verCode = res.data.image
        if (this.formType == 0) {
          this.registerForm.verKey = res.data.key
        } else {
          this.loginForm.verKey = res.data.key
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

.login_index {
  height: 100vh;
  width: 100vw;
  //background: red;
  display: flex;
  overflow: hidden;

  .login_leftBox {
    //width: 70%;
    flex: 1;
    height: 100%;
    background: #025AA7;
    background: url("~@/assets/image/loginImage.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .login_rightBox {
    width: 500px;
    //flex: 1;
    height: 100%;
    background: #fff;

    .login_formBox {
      height: 100%;
      margin-left: 50px;
      display: flex;
      flex-direction: column;
      margin-top: 100px;

      .login_welcomeText {
        height: 94px;
        font-family: YouSheBiaoTiHei;
        font-size: 36px;
        color: #1C85F6;
        letter-spacing: 0;
      }

      .login_checkType {
        display: flex;
        width: 38%;
        //border: 1px solid;
        justify-content: space-between;
        margin-top: 52px;

        .login_checkType_item {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 17px;
          color: #666666;
          letter-spacing: 0;
          cursor: pointer;
          user-select: none;
          //padding-bottom: 20px;
        }

        .login_checkType_item_checked {
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
          font-size: 17px;
          color: #1C85F6;
          letter-spacing: 0;
          cursor: pointer;
          user-select: none;

          .item_checked_icon {
            width: 100%;
            height: 1px;
            background: #1C85F6;
            margin-top: 3px;
          }
        }

      }

      .login_form_input {
        width: 89%;
        margin-top: 52px;

        .sendBtn {
          width: 100%;
          height: 44px;
          background: #1C85F6;
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-SNaNpxibold;
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          margin-top: 120px;
          cursor: pointer;
          user-select: none;
        }

        .input_button {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .verCode {
            margin-left: 10px;
            border: 1px solid #cecece;
            font-size: 13px;
            width: 175px;
            height: 40px;

            img {
              height: 94%;
              width: 100%;
              display: inline;

            }
          }
        }

        .sendCodeBtn {
          margin-left: 10px;
          background: #1C85F6;
          border: none;
          font-size: 13px;
          width: 113px;
        }
      }

    }

    .login_form_inputAction {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .forGetPassword {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #1C85F6;
        letter-spacing: 0;
        cursor: pointer;
        user-select: none;
      }
    }
  }
}
</style>
